import store from 'store';
import actions from 'store/actions/order';

export const getOrderById = async (orderId) => {
  return store().dispatch(actions.getOrderById(orderId));
};
export const getOrdersFromShipment = async (queryString) => {
  return store().dispatch(actions.getOrdersFromShipment(queryString));
};

export const courierAssignments = async (payload) => {
  return store().dispatch(actions.courierAssignments(payload));
};

export const getOrderItemProperties = async (queryString) => {
  return actions.getOrderItemProperties(queryString);
};

export const editOrderItemProperties = async (orderItemProperties) => {
  return actions.editOrderItemProperties(orderItemProperties);
};

export const getOrdersLocations = async (boundaries) => {
  return actions.getOrdersLocations(boundaries);
};

export const cancelOrderManually = async (id) => {
  return actions.cancelOrderManually(id);
};
export const deliverOrderManually = async (id) => {
  return actions.deliverOrderManually(id);
};
export const notDeliverOrderManually = async (id) => {
  return actions.notDeliverOrderManually(id);
};
export const completedOrderManually = async (id) => {
  return actions.completedOrderManually(id);
};
export const getOrderHistory = async (id) => {
  return actions.getOrderHistory(id);
};
export const orderTransfer = async (data) => {
  return actions.orderTransfer(data);
};
export const getZonesWithCurrentSlot = async (id) => {
  return actions.getZonesWithCurrentSlot(id);
};
export const getWaitingCancelItems = async (queryString) => {
  return actions.getWaitingCancelItems(queryString);
};
export const getCancellationReason = async (queryString) => {
  return actions.getCancellationReason(queryString);
};
export const approveCancelOrder = async (data) => {
  return actions.approveCancelOrder(data);
};
export const getOrdersWaitingTransfer = async (queryString) => {
  return actions.getOrdersWaitingTransfer(queryString);
};
export const orderMapDetail = async (data) => {
  return actions.orderMapDetail(data);
};
export const orderMapStoresPolygon = async (data) => {
  return actions.orderMapStoresPolygon(data);
};
export const orderPolygonDetail = async () => {
  return actions.orderPolygonDetail();
};
export const orderPolygonSave = async (data) => {
  return actions.orderPolygonSave(data);
};
export const orderPolygonEdit = async (data, id) => {
  return actions.orderPolygonEdit(data, id);
};
export const orderPolygonDelete = async (id) => {
  return actions.orderPolygonDelete(id);
};
export const orderPolygonParameter = async (queryString) => {
  return actions.orderPolygonParameter(queryString);
};
export const getStoreCourierSource = async (queryString) => {
  return actions.getStoreCourierSource(queryString);
};
export const deleteStoreCourierSource = async (id) => {
  return actions.deleteStoreCourierSource(id);
};
export const addStoreCourierSource = async (payload, type) => {
  return actions.addStoreCourierSource(payload, type);
};
export const getCourierSource = async () => {
  return actions.getCourierSource();
};
export const editStoreCourierSource = async (payload) => {
  return actions.editStoreCourierSource(payload);
};
export const orderExportDetail = async (data) => {
  return actions.orderExportDetail(data);
};